/**
 * Próg kwotowy opłaty urzędowej — odpowiednik FEE_APPROVAL_THRESHOLD
 * z backendu (apps/official_fees/models.py). Zmiana musi iść parami.
 *
 * Do tej kwoty włącznie koordynator akceptuje opłatę na swoim przedsięwzięciu sam;
 * powyżej decyduje dyrektor, a opis przestaje być opcjonalny — dla każdego
 * wnioskującego, także dla dyrektora i dla opłaty dodawanej jako już zapłacona.
 */
export const FEE_APPROVAL_THRESHOLD = 105;

/** Czy dla tej kwoty (surowy string z formularza) opis jest obowiązkowy. */
export function isDescriptionRequired(amount: string | undefined): boolean {
  const parsed = parseFloat(amount ?? "");
  return !isNaN(parsed) && parsed > FEE_APPROVAL_THRESHOLD;
}
